/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityPasswordInputIcon16Solid = forwardRef('SecurityPasswordInputIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 5.75A2.75 2.75 0 0 1 2.75 3h10.5A2.75 2.75 0 0 1 16 5.75v4.5A2.75 2.75 0 0 1 13.25 13H2.75A2.75 2.75 0 0 1 0 10.25v-4.5ZM4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.333 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4.334-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM13 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
